<div class="title">
  <h5>{{attr.name}}</h5>
  <ng-content></ng-content>
</div>
<div class="values">
  @for (value of attr.values; track $index) {
  <div
    class="value"
    [ngClass]="{active:activeValue?.id===value.id}"
    (click)="select(value)"
  >
    @if (value.image) {
    <img
      [ngSrc]="value.image|fileurl"
      width="88"
      height="88"
      alt="product attr image"
    />
    }
    <span>{{value.name}}</span>
  </div>
  }
</div>
